import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AddService from './pages/add-service';
import AddBusiness from './pages/add-business';
import SearchResults from './pages/search-results';
import Login from './pages/login';
import BusinessDetail from './pages/business-detail';
import HomeDirectory from './pages/home-directory';
import UserProfile from './pages/user-profile';
import Register from './pages/register';
import TermsConditions from './pages/terms-conditions';
import PrivacyPolicy from './pages/privacy-policy';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeDirectory />} />
        <Route path="/add-service" element={<AddService />} />
        <Route path="/add-business" element={<AddBusiness />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/login" element={<Login />} />
        <Route path="/business-detail" element={<BusinessDetail />} />
        <Route path="/business-detail/:businessId" element={<BusinessDetail />} />
        <Route path="/home-directory" element={<HomeDirectory />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/register" element={<Register />} />
        {/* Authentication callback route for email verification */}
        <Route path="/auth/callback" element={<Register />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Legacy route redirects */}
        <Route path="/add-listing" element={<AddBusiness />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;